import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './quote-button.module.scss';
import { applyClasses, applyProps } from '../shared/js';
import { Button } from '..';
import Container from './Container';

const QuoteButton = ({ id, href, title, children, ...props }) => (
  <div
    className={cn(
      styles.outer,
      // eslint-disable-next-line react/prop-types
      props.className,
      applyClasses({ fullWidth: props.fullWidth }, styles)
    )}
    {...applyProps(props)}
  >
    <Button
      id={id}
      className={cn(styles.button, applyClasses(props, styles))}
      href={href}
    >
      {title && <p className={styles.title}>{title}</p>}
      <div className={styles.inner}>{children}</div>
    </Button>
  </div>
);

QuoteButton.propTypes = {
  /** The ID of the button. Useful to select the button during testing. */
  id: PropTypes.string,
  /** The link the button should point to */
  href: PropTypes.string,
  /** The title shown at the top of the button */
  title: PropTypes.string,
  /** The contents of the button */
  children: PropTypes.any,
  /** Set to true if the button should span the entire row */
  fullWidth: PropTypes.bool,
};

QuoteButton.defaultProps = {
  href: undefined,
  title: undefined,
  children: undefined,
  fullWidth: undefined,
};

QuoteButton.Container = Container;
export default QuoteButton;
